import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl } from '@angular/forms';

@Component({
  selector: 'app-form-date-picker',
  templateUrl: './form-date-picker.component.html',
  styleUrls: ['./form-date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormDatePickerComponent),
      multi: true
    }]
})
export class FormDatePickerComponent implements OnInit, ControlValueAccessor, AfterViewInit {
  @ViewChild('datePicker', { static: false }) datePicker;
  @Input() placeholder;
  @Input() dateConfig;
  @Input() control: FormControl;
  @Input() showEditIcon = false
  @Output() onChange = new EventEmitter();
  _shiftDate: string;
  propagateChange = (_: any) => {};
  propagateTouched = (_: any) => {};

  constructor(private host: ElementRef) { }

  ngOnInit() {
  }



  private closeOnOutside = (event: Event) => {
    const pickerEl = this.host.nativeElement.querySelector('dp-date-picker');
    const pencilEl = this.host.nativeElement.querySelector('.reusable-form-component'); // adjust selector
  
    if (
      (pickerEl && pickerEl.contains(event.target)) ||
      (pencilEl && pencilEl.contains(event.target))
    ) {
      return;
    }
  
    try {
      this.datePicker.api.close(); // For v14+
    } catch {
      this.datePicker.datePickerService?.close();
    }
  };
  
  ngAfterViewInit() {
    document.addEventListener('click', this.closeOnOutside, { passive: true });
    document.addEventListener('touchstart', this.closeOnOutside, { passive: true });
  }
  
  ngOnDestroy() {
    document.removeEventListener('click', this.closeOnOutside);
    document.removeEventListener('touchstart', this.closeOnOutside);
  }
  
  
  get shiftDate(): string {
    return this._shiftDate;
  }

  set shiftDate(value: string) {
      this._shiftDate = value;
      this.onChange.emit(this._shiftDate);
      this.propagateChange(this._shiftDate);
  }

  //Form Accessor Functions
  writeValue(value: any): void {
    this._shiftDate = value;
  }

  registerOnChange(fn: (value: any) => void): void {
      this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void): void {
      this.propagateTouched = fn;
  }

  openDatePicker(datePickerElement: any){
    if(datePickerElement && datePickerElement.api && datePickerElement.api.open){
      datePickerElement.api.open()
     }
  }


}
